import {useContext} from 'react'
import {ConnectionsContext} from './ConnectionsContext'

export const useConnections = () => {
  const contextInstance = useContext(ConnectionsContext)
  if (!contextInstance) throw new Error('Cannot call useConnections() outside of <ConnectionsProvider>')
  return contextInstance
}
